#import './core-entity-task-step-shared-fragment.graphql'

fragment CoreEntityTaskFragment on Task {
    ...CoreEntityTaskStepSharedFragment
    id
    createdTime
    linkifiedDescription
    isAiGenerated
    creatorEntity {
        id
        name
        ... on Activity {
            htmlUrlPath
        }
    }
    assigner {
        id
        name
    }
    assignedTime
    recurringPeriod
    isRecurringForUser
}
